module.exports = __webpack_public_path__ + "img/audio.6ea84a18.svg";